import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Box,
  CircularProgress,
  Typography,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { getRoleChip } from "./adminRoles";
import { fDateTime } from "src/utils/formatTime";

export default function AdminsTable({
  admins,
  loading,
  isSuperAdmin,
  currentUserId,
  onOpenMenu,
}) {
  const isSelf = (admin) => admin.id === currentUserId;
  const colSpan = isSuperAdmin ? 8 : 7;

  return (
    <Card>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>MFA</TableCell>
              <TableCell>Last Login</TableCell>
              <TableCell>Created</TableCell>
              {isSuperAdmin && <TableCell align="right">Actions</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={colSpan} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={28} />
                </TableCell>
              </TableRow>
            ) : admins.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={colSpan}
                  align="center"
                  sx={{ py: 6, color: "text.secondary" }}
                >
                  No admin users found.
                </TableCell>
              </TableRow>
            ) : (
              admins.map((admin) => (
                <TableRow key={admin.id} hover>
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      {admin.name ?? (
                        <Typography variant="body2" color="text.secondary">
                          —
                        </Typography>
                      )}
                      {isSelf(admin) && (
                        <Chip
                          label="You"
                          size="small"
                          variant="outlined"
                          sx={{ fontSize: 10 }}
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>{admin.email}</TableCell>
                  <TableCell>{getRoleChip(admin.role)}</TableCell>
                  <TableCell>
                    <Chip
                      label={admin.is_active ? "Active" : "Inactive"}
                      color={admin.is_active ? "success" : "default"}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={admin.mfa_enabled ? "Enabled" : "Disabled"}
                      color={admin.mfa_enabled ? "success" : "default"}
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>
                    {admin.last_login_at ? (
                      fDateTime(admin.last_login_at)
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        Never
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>{fDateTime(admin.created_at)}</TableCell>
                  {isSuperAdmin && (
                    <TableCell align="right">
                      <Tooltip
                        title={
                          isSelf(admin)
                            ? "Cannot modify your own account"
                            : "Actions"
                        }
                      >
                        <span>
                          <IconButton
                            size="small"
                            disabled={isSelf(admin)}
                            onClick={(e) => onOpenMenu(e, admin)}
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  )}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
